/**
 *
 * 根据login页面的type字段决定登陆成功后要跳转的页面
 * */
export default {
    WX_ORDER: 'WX_CX3_ORDER_FROM_OWF', // 微信下单页
    WX_QUERY: 'WX_CX3_QUERY_FROM_OWF', // 微信查单页
    WX_MYSF: 'WX_CX3_MYSF_FROM_OWF', // 微信我的
    WX_ACCEPT: 'WX_CX3_STANDARD_FROM_OWF', // 微信收寄标准
    OWF_HOME: '' // 官网首页
}



// WEBPACK FOOTER //
// ./src/constant/loginType.js